<!--
  A small element to display the errors from children ElFormSmallItem
-->

<template>
  <div class="el-form-errors">
    <slot></slot>
    <slide-up-down
      :active="validateMessages.length && showMessage && elForm && elForm.showMessage ? true : false"
      :duration="200">
      <slot
        name="errors"
        :errors="validateMessages">
        <div v-for="(validateMessage, index) in validateMessages" :key="index"
          style="display: block"
          class="el-form-item__error"
          :class="{
            'el-form-item__error--inline': typeof inlineMessage === 'boolean'
              ? inlineMessage
              : (elForm && elForm.inlineMessage || false)
          }"
        >
          {{validateMessage}}
        </div>
      </slot>
    </slide-up-down>
  </div>
</template>

<script>
import SlideUpDown from 'vue-slide-up-down'

export default {
  name: 'ElFormErrors',

  componentName: 'ElFormErrors',

  components: {
    SlideUpDown,
  },

  provide () {
    return {
      elFormErrors: this,
    }
  },

  inject: {
    elForm: {
      default: null,
    },
  },

  props: {
    inlineMessage: {
      type: [String, Boolean],
      default: true,
    },
    showMessage: {
      type: Boolean,
      default: true,
    },
  },

  data () {
    return {
      fields: [],
    }
  },

  computed: {
    validateMessages () {
      return this.fields.filter(f => f.validateState === 'error' && f.showMessage)
        .map(f => f.validateMessage).filter(m => m)
    },
  },

  methods: {
    addField (field) {
      if (field) {
        this.fields.push(field)
      }
    },
    removeField (field) {
      if (field.prop) {
        this.fields.splice(this.fields.indexOf(field), 1)
      }
    },
  },
}
</script>
